import { isLogin, RequestFavorites, RequestFavoriteSymbol } from "../../NetworkFactory"
import { ToastContent } from "../factory/FactoryUtil"

let cacheFavoriteData = []
let initFavoriteRquest = false

// # 请求关注币种
const requestData = () => {
    RequestFavorites().then(response => {
        cacheFavoriteData = response.data.data || []
    })
}

// # 初始化
export const initFavoriteRquestData = () => {
    if(!isLogin()) {
        return
    }
    if(initFavoriteRquest) {
        return
    }
    initFavoriteRquest = true
    requestData()
}

export const isFollowed = (symbol = '') => {
    initFavoriteRquestData()
    if(symbol === '') {
        return false
    }
    else if(!isLogin()) {
        return false
    }
    if(cacheFavoriteData.length === 0) {
        return false
    }
    for(let i=0;i<cacheFavoriteData.length;i++) {
        if(cacheFavoriteData[i].symbol === symbol) {
            return true
        }
    }
   return false
}

// # 提交关注币种
export const DoFavorite = (symbol = '') => {
    if(isLogin()) {
        RequestFavoriteSymbol(symbol).then(response => {
            const {status = -1} = response.data || {}
            if(status === 100) {
                ToastContent('Favorite success')
                requestData()
            }
            else if(status === 200) {
                ToastContent('Unfollow success')
                requestData()
            } 
            else {
                ToastContent('Unknown error')
            }
        }).catch(()=> {
            ToastContent('Unknown error')
        })
    }
    else {
        ToastContent('Please login first')
    }
}